var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchitectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.784,
    height: 72.431,
    viewBox: "0 0 47.784 72.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "architect",
    transform: "translate(-14 -3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11836",
    "data-name": "Path 11836",
    d: "M16.515,48.457A1.352,1.352,0,0,0,15.257,47.2,1.352,1.352,0,0,0,14,48.457v2.515a1.352,1.352,0,0,0,1.257,1.257,1.352,1.352,0,0,0,1.257-1.257Z",
    transform: "translate(0 11.329)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11837",
    "data-name": "Path 11837",
    d: "M52.515,48.457a1.257,1.257,0,0,0-2.515,0v2.515a1.257,1.257,0,0,0,2.515,0Z",
    transform: "translate(9.269 11.329)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11838",
    "data-name": "Path 11838",
    d: "M52.575,47.408V41.75L40,37.6V62.624l12.575,4.15V56.965a3.663,3.663,0,0,1-2.515-3.521V50.929A3.663,3.663,0,0,1,52.575,47.408Z",
    transform: "translate(6.694 8.857)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11839",
    "data-name": "Path 11839",
    d: "M16,47.408a3.663,3.663,0,0,1,2.515,3.521v2.515A3.663,3.663,0,0,1,16,56.965v5.659l12.575,4.15V41.75L16,37.6Z",
    transform: "translate(0.515 8.857)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11840",
    "data-name": "Path 11840",
    d: "M28,66.774l12.575-4.15V37.6L28,41.75Z",
    transform: "translate(3.605 8.857)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11841",
    "data-name": "Path 11841",
    d: "M48.4,34.332,41.732,33.2a12.309,12.309,0,0,1-10.311,0l-6.665,1.132A8.221,8.221,0,0,0,19.6,37.475l9.557,3.144,15.09-5.03,10.563,3.4A9.772,9.772,0,0,0,48.4,34.332Z",
    transform: "translate(1.442 7.724)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11842",
    "data-name": "Path 11842",
    d: "M30,28.7v3.647a9.808,9.808,0,0,0,7.545,0V28.7A11.358,11.358,0,0,1,30,28.7Z",
    transform: "translate(4.12 6.566)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11843",
    "data-name": "Path 11843",
    d: "M43.609,19.2H26c-.377,6.162,3.9,10.06,8.8,10.06A8.832,8.832,0,0,0,43.609,19.2Z",
    transform: "translate(3.085 4.12)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    d: "M23.257,17.715h25.15a1.352,1.352,0,0,0,1.257-1.257A1.352,1.352,0,0,0,48.407,15.2H23.257A1.352,1.352,0,0,0,22,16.457,1.352,1.352,0,0,0,23.257,17.715Z",
    transform: "translate(2.06 3.09)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11845",
    "data-name": "Path 11845",
    d: "M39.064,6.344V12a1.257,1.257,0,0,1-2.515,0V3.2H34.034V12a1.257,1.257,0,1,1-2.515,0V6.344A10.841,10.841,0,0,0,24.1,15.775H46.609A11.484,11.484,0,0,0,39.064,6.344Z",
    transform: "translate(2.601)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectIcon);
export default __webpack_public_path__ + "static/media/architect_icon.9572d85ab83aab84e3e5ab10736d88fb.svg";
export { ForwardRef as ReactComponent };